<template>
    <div @dblclick.stop>
        <div
            :ref="'textBox'"
            :class="{ 'lb-collapsed-text': collapseText }"
            class="lb-collapsable-text"
            v-html="text"
        ></div>
        <a
            v-if="text.length > 200 || showButtons"
            v-t="
                collapseText ? 'Object.view_more_text' : 'Object.view_less_text'
            "
            class="is-uppercase has-text-primary has-text-weight-bold"
            @click.stop="collapseText = !collapseText"
        ></a>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            required: true,
            type: String,
            default: '',
        },
    },
    data() {
        return {
            collapseText: true,
            showButtons: false,
        };
    },
    computed: {},
    mounted() {
        const lines = this.$refs.textBox.getElementsByTagName('p').length;
        if (lines > 5) {
            this.showButtons = true;
        }
    },
    destroyed() {},
    methods: {},
};
</script>

<style scoped>
.lb-collapsable-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.lb-collapsed-text {
    -webkit-line-clamp: 4;
    line-clamp: 4;
    word-break: break-word;
    max-height: 6.2rem;
}
.lines-3 .lb-collapsed-text {
    -webkit-line-clamp: 3 !important;
    line-clamp: 3 !important;
    word-break: break-word;
    max-height: 6.2rem;
}
/deep/ ol {
    list-style: auto;
    padding: 0 1rem;
}
/deep/ ul {
    list-style: unset;
    padding: 0 1.5rem;
}
</style>
